import React, { memo } from "react";
import { Box, Grid, FormControlLabel, IconButton } from "@mui/material";
import { FieldArrayRenderProps, FormikProps, useFormikContext } from "formik";
import { Delete } from "@mui/icons-material";
import { Data } from "../../../store/merchant/types";
import CustomizedCheckbox from "./../../../common/formElements/Checkbox";
import { get } from "lodash";
import TextInput from "../../../common/formElements/TextInput";

interface MerchantAdditionalDataInput {
  arrayHelpers: FieldArrayRenderProps;
  index: number;
  dataIndex: number;
  disabled?: boolean;
}

const MerchantAdditionalDataInput = (props: MerchantAdditionalDataInput) => {
  const { arrayHelpers, index, dataIndex, disabled } = props;
  const formProps = useFormikContext();
  const { values, setFieldValue } = formProps as FormikProps<Data>;
  const isEncrypted =
    values.attributes?.Processor &&
    values.attributes.Processor[index]?.AdditionalData &&
    values.attributes.Processor[index]?.AdditionalData[dataIndex]?.Encrypted;
  const isEncryptedDisabled = !get(
    values,
    `attributes.Processor[${index}].AdditionalData[${dataIndex}].isNew`
  );

  return (
    <>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Tag`}
          label="Tag"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <TextInput
          fieldname={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Value`}
          label="Value"
          disabled={disabled}
        />
      </Grid>
      <Grid item xs={12} md={4}>
        <Box>
          <FormControlLabel
            control={
              <CustomizedCheckbox
                checked={isEncrypted}
                onChange={(
                  _event: React.FormEvent<HTMLInputElement>,
                  data: boolean
                ) => {
                  setFieldValue(
                    `attributes.Processor[${index}].AdditionalData[${dataIndex}].Encrypted`,
                    data
                  );
                }}
                name={`attributes.Processor[${index}].AdditionalData[${dataIndex}].Encrypted`}
                disabled={disabled}
              />
            }
            label="Encrypted"
            disabled={isEncryptedDisabled}
          />

          <IconButton
            aria-label="delete"
            onClick={() => {
              arrayHelpers.remove(dataIndex);
            }}
            disabled={disabled}
          >
            <Delete fontSize="small" />
          </IconButton>
        </Box>
      </Grid>
    </>
  );
};

export default memo(MerchantAdditionalDataInput);
